import { StationNavigatorBreadcrumb } from '@app/components/base/stations/StationNavigatorBreadcrumb';
import { Page } from '@app/components/page/Page';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { useIntl } from 'react-intl';
import { AuditModule } from '../../..';
import { AuditIcon } from '../../../components/AuditIcon';
import { getAuditStationHeaderLinks } from './StationLinks';

interface Props {
  title: string;
  children: React.ReactNode;
}

export function StationAuditPage({ title, children }: Props) {
  const station = useActiveStation();
  const { $t } = useIntl();

  return (
    <Page htmlTitle={[title, station.name]}>
      <Page.Header
        icon={<AuditIcon />}
        title={[
          $t({
            id: 'audit.title',
            defaultMessage: 'Auditoría',
          }),
          <StationNavigatorBreadcrumb
            key={station.id}
            basePath={AuditModule.basePath}
            activeId={station.id}
          />,
        ]}
        tabs={getAuditStationHeaderLinks(station, $t)}
      />
      {children}
    </Page>
  );
}
